import { useContext, useEffect, useRef } from "react";
import styled from "styled-components";
import css from "@styled-system/css";

import { DatePickerContext } from "./DatePickerContext";
import { DatePickerDropdownProps, DisplayMode } from "./datePicker.type";

import Box from "../Box/Box";

import DatePickerCalendar from "./DatePickerCalendar";
import DatePickerControls from "./DatePickerControls";

const DatePickerDropdownContainer = styled(Box)<{ displayMode: DisplayMode }>`
  width: 324px;
  max-width: 324px;
  height: 342px;
  top: calc(100% + 20px);
  z-index: 10;
  ${(props) =>
    css({
      position: props.displayMode === "dropdown" ? "absolute" : "relative",
      backgroundColor: "primary-white",
      padding: props.displayMode === "dropdown" ? 3 : 1,
      marginTop: props.displayMode === "dropdown" ? 0 : 3,
      ...(props.displayMode === "dropdown" && {
        borderRadius: 2,
        borderColor: "msg-blue-border",
        borderStyle: "solid",
        borderWidth: "2px",
      }),
    })}
`;

const DatePickerDropdown = ({
  displayMode = "dropdown",
  disabledDays,
  minDate,
  maxDate,
  dateFormat,
  rangePicker,
  onChange,
  onRangeChange,
  onToggle,
}: DatePickerDropdownProps) => {
  const { showCalendar } = useContext(DatePickerContext);
  const initialRender = useRef(true);

  useEffect(() => {
    if (initialRender.current) {
      initialRender.current = false;
      return;
    }

    const openState = showCalendar ? "open" : "close";
    onToggle(openState);
  }, [showCalendar, onToggle]);

  if (displayMode === "dropdown" && !showCalendar) {
    return null;
  }

  return (
    <DatePickerDropdownContainer
      displayMode={displayMode}
      aria-label="datepicker dropdown"
    >
      <DatePickerControls minDate={minDate} maxDate={maxDate} />
      <DatePickerCalendar
        disabledDays={disabledDays}
        minDate={minDate}
        maxDate={maxDate}
        dateFormat={dateFormat}
        rangePicker={rangePicker}
        onChange={onChange}
        onRangeChange={onRangeChange}
      />
    </DatePickerDropdownContainer>
  );
};

export default DatePickerDropdown;
